<template>
  <div
    :class="$style.rootContainer"
    :name="`${name}-searchBar`"
    @click="handleFocus"
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" :class="$style.searchIcon" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M22.829 21.312a12.043 12.043 0 002.9-7.86c0-6.684-5.418-12.102-12.102-12.102S1.525 6.768 1.525 13.452s5.418 12.102 12.102 12.102a12.05 12.05 0 007.413-2.535l-.027.021 7.622 7.61 1.766-1.766zm-9.146 1.728c-5.302 0-9.6-4.298-9.6-9.6s4.298-9.6 9.6-9.6a9.6 9.6 0 019.6 9.6 9.6 9.6 0 01-9.6 9.6z"/></svg>
    <div :class="$style.searchContainer">
      <div
        v-if="selectedValue && selectedValue.value"
        :class="$style.pillContainer"
      >
        <Pill
          :ref="`pill-${selectedValue.value}`"
          :disabled="disabled"
          :handleDeleteButtonClick="() => handleFilterDelete()"
          :name="`${name}-value`"
          :showDeleteButton="true"
          :text="displayName"
        />
      </div>
      <div
        v-else
        :class="$style.inputContainer"
      >
        <input
          ref="searchInput"
          :class="$style.searchInput"
          :disabled="disabled"
          :name="`${name}-input`"
          :placeholder="placeholderText"
          type="text"
          :value="searchText"
          @blur="handleBlur"
          @input="handleSearchInput"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import Pill from 'client/components/Buttons/Pill.vue';

/**
 *   @event {string} input - search value has changed
 *   @event {{ value: any, name: string}} filterDelete - filter delete has been clicked
 *   @event focus - SearchBar has focus
 *   @event blur - SearchBar has lost focus
 */
export default {
  name: 'SearchBar',

  components: {
    Pill,
  },

  mixins: [
    clickaway,
  ],

  props: {
    disabled: Boolean,
    name: {
      type: String,
      required: true,
    },
    placeholderText: {
      type: String,
      default: 'Search',
    },
    searchText: {
      type: String,
      required: true,
    },
    /**
     * @type {{ value: any, name: string }}
     */
    selectedValue: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    inputTextLeft: 0,
    searchClearButtonLeft: 80,
  }),

  computed: {
    displayName() {
      if (!this.selectedValue) {
        return '';
      }

      const { title, subtitle } = this.selectedValue;

      let displayName = '';
      if (title) {
        displayName = subtitle ? `${title} (${subtitle})` : title;
      }

      return displayName;
    },
  },

  methods: {
    handleBlur() {
      this.$emit('blur');
    },

    handleFilterDelete() {
      if (!this.disabled) {
        this.$emit('filterDelete');
        this.$nextTick(() => this.handleFocus());
      }
    },

    /**
     * Force focus on the input when the user clicks anywhere in the search bar.
     */
    handleFocus() {
      if (this.$refs.searchInput) {
        this.$refs.searchInput.focus();
      }

      this.$emit('focus');
    },

    handleSearchClearButtonClick() {
      this.$emit('input', '');
    },

    handleSearchInput(event) {
      const { value } = event.target;
      this.$emit('input', value);
    },
  },
};
</script>

<style scoped module>
@import "../SearchWithMultiSelect/css/SearchBar.css";

.searchIcon {
  fill: var(--jcPrimary);
}

.searchInput,
.searchContainer {
  width: 100%;
}
</style>
